import React from 'react';
import LoaderIcon from 'react-loaders';

const Loader = () => {
  return <LoaderIcon type="ball-spin-fade-loader" />;
};

export default Loader;
